import { create } from "zustand";

interface DarkModeStoreType {
  isDarkMode: boolean;
  setIsDarkMode: (value: boolean) => void;
}

const useDarkModeStore = create<DarkModeStoreType>((set) => ({
  isDarkMode: false,
  setIsDarkMode: (value: boolean) => {
    set({ isDarkMode: value });
  },
}));

export default useDarkModeStore;
